import { Account } from "./accounts-dropdown.types";
import { DropdownOption } from "../dropdown/dropdown.types";

export const getAccountsOptions = (accounts: readonly Account[]): DropdownOption[] =>
	accounts.map((account) => ({ label: account.name, value: account.id }));
